<template>
  <!-- <component :is="layout"> -->
  <router-view />
  <!-- </component> -->
</template>

<script>
import Push from 'push.js'

export default {
  mounted() {
    this.checkVersion()
  },
  methods: {
    checkVersion() {
      fetch("/version.json", { cache: "no-cache" })
        .then((response) => response.json())
        .then((data) => {
          const newVersion = data.version;
          const currentVersion = localStorage.getItem("version") || ''
          if (currentVersion && newVersion != currentVersion) {
            console.log('nueva version')
            //alert("nueva version")
            window.location.reload(true)
          } if (currentVersion == '') {
            window.location.reload(true)
          }
          localStorage.setItem("version", newVersion)
        })
        .catch((err) => console.error("error al verificar version", err))
    }
  },
  sockets: {
    connect: function () {
      console.log("conectado a cockets.");
    },
    new_order: async function (data) {
     
    },
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    }
  }
};
</script>
<style lang="scss">
body,
input,
label,
button,
span {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 15px !important
}

.span5 {
  margin-left: 2.5px;
  margin-right: 2.5px;
}

.sweet-modal-overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

input,
textarea,
select {
  border: 1px solid rgb(133, 129, 129) !important
}

.bgcontainer {
  background-color: #E5E5E5
}

.main-sidebar {
  width: 90% !important
}
</style>